import { ContentContainer } from "@/components/ContentContainer";
import PageHead from "@/components/PageHead";
import { Spinner } from "@/components/Spinner";
import { contentFullscreenState } from "@/context/states";
import {
  useAllRegions,
  useLocationCategories,
  useLocationsFromProxy,
  useZipcodes,
} from "@/lib/api";
import { ClusterStyles, MapStyles } from "@/styles/map";
import "mapbox-gl/dist/mapbox-gl.css";
import { useRecoilState } from "recoil";
import PopMap from "ui/components/PopMap";

export default function SharedMap({ page }) {
  const {
    locations,
    isError: isLocationsError,
    isLoading: isLocationsLoadings,
  } = useLocationsFromProxy();
  const {
    categories,
    isLoading: isCategoriesLoading,
    isError: isCategoriesError,
  } = useLocationCategories([17, 18]);
  const {
    regions,
    isLoading: isRegionsLoading,
    isError: isRegionsError,
  } = useAllRegions();
  const { zipcodes, isLoading: isZipcodesLoading } = useZipcodes();

  const mapboxAccessToken = process.env.NEXT_PUBLIC_MAPBOX_TOKEN;
  const [contentFullscreen, setContentFullscreen] = useRecoilState(
    contentFullscreenState,
  );

  const toggleFullscreen = () => {
    setContentFullscreen(!contentFullscreen);
  };

  if (isLocationsError) return <p>Error: {isLocationsError.message}</p>;
  if (isCategoriesError) return <p>Error: {isCategoriesError.message}</p>;

  return (
    <>
      <PageHead page={page} />
      <ContentContainer
        headline={page?.headline}
        subheadline={page?.subheadline}
        image={page?.hero_image?.formats?.large?.url}
        variant={contentFullscreen ? "fullscreen" : "shared-map"}
      >
        {isLocationsLoadings || isCategoriesLoading || isZipcodesLoading ? (
          <Spinner />
        ) : (
          <PopMap
            locations={locations}
            mapboxAccessToken={mapboxAccessToken}
            categories={categories}
            landkreise={regions?.filter((r) => r.regiontype === "landkreis")}
            regions={regions}
            zipcodes={zipcodes}
            onFullscreenToggled={toggleFullscreen}
            contentFullscreen={contentFullscreen}
            createLocationUrl={process.env.NEXT_PUBLIC_LOCATION_CREATE_URL}
            clusterStyles={ClusterStyles}
            mapSkin={MapStyles}
          />
        )}
      </ContentContainer>
    </>
  );
}

export const getStaticProps = async () => {
  const pageResponse = await fetch(
    `${process.env.NEXT_PUBLIC_API_URL || "http://localhost:1337"}/networks`,
  );
  const page = await pageResponse.json();

  return {
    props: {
      page,
    },
    revalidate: parseInt(process.env.SSG_REVALIDATE_TIMEOUT),
  };
};
